import axios from 'axios';
import { API } from '../../constants';

const createAction = name => ({
  GET_PAYMENT_TYPE_PENDING: `${name}_GET_PAYMENT_TYPE_PENDING`,
  GET_PAYMENT_TYPE_SUCCESS: `${name}_GET_PAYMENT_TYPE_SUCCESS`,
  GET_PAYMENT_TYPE_FAILED: `${name}_GET_PAYMENT_TYPE_FAILED`
});

export const PAYMENT_TYPE = createAction('PAYMENT_TYPE');

////// GET
export const GetPaymentType = () => async (dispatch, getState) => {
  dispatch({ type: PAYMENT_TYPE.GET_PAYMENT_TYPE_PENDING });
  try {
    const { currentLanguage } = getState().language;
    let result = await axios
      .get(API.GET_PAYMENT_TYPE, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': currentLanguage
        }
      })
      .then(res => res.data)
      .catch(error => Promise.resolve(null));

    if (!result) {
      result = [
        {
          id: '1',
          paymentGroup: 'SF Plus',
          paymentType: 'SF Plus',
          enable: true
        },
        {
          id: '2',
          paymentGroup: 'Credit/Debit Card',
          paymentType: 'K Payment',
          enable: false
        },
        {
          id: '3',
          paymentGroup: 'Credit/Debit Card',
          paymentType: '2C2P',
          enable: true
        },
        {
          id: '4',
          paymentGroup: 'QR code payment',
          paymentType: 'Thai QR',
          enable: true
        }
      ];
    }

    let defaultCreditCardPaymentGatway = null;
    let paymentType_sfPlus = true;
    let paymentType_qrCode = true;

    if (result && result.length > 0) {
      for (let i = 0; i <= result.length - 1; i++) {
        if (result[i].paymentType === 'K Payment' && result[i].enable) {
          defaultCreditCardPaymentGatway = result[i].paymentType;
        } else if (result[i].paymentType === '2C2P' && result[i].enable) {
          defaultCreditCardPaymentGatway = result[i].paymentType;
        } else if (result[i].paymentType === 'SF Plus') {
          paymentType_sfPlus = result[i].enable;
        } else if (result[i].paymentType === 'Thai QR') {
          paymentType_qrCode = result[i].enable;
        }
      }
    }

    dispatch({
      type: PAYMENT_TYPE.GET_PAYMENT_TYPE_SUCCESS,
      payload: {
        data: result,
        defaultCreditCardPaymentGatway: defaultCreditCardPaymentGatway,
        paymentType_sfPlus,
        paymentType_qrCode
      }
    });
  } catch (error) {
    dispatch({ type: PAYMENT_TYPE.GET_PAYMENT_TYPE_FAILED });
  }
};
